import Dashboard from '../pages/dashboard/Dashboard.jsx';
import Client from '../pages/teacher/Teacher.jsx';
import ClientDetails from '../pages/teacher/components/TeacherDetails.jsx';
import Student from '../pages/student/Student.jsx';
import Task from '../pages/task/Task.jsx';
import Banner from '../pages/banner/Banner.jsx';
import ResetPassword from '../pages/authpage/ResetPassword.jsx';
import ForgetPassword from '../pages/authpage/ForgetPassword.jsx';
import Login from '../pages/authpage/Login.jsx';
import ForgetPasswordotp from '../pages/authpage/forget_otp.jsx';
import Ticket from '../pages/support/ticket/Ticket.jsx';
import ViewTicket from '../pages/support/ticket/ViewTicket.jsx';
import Faq from "../pages/support/faq/Faq.jsx";
import FAQs from '../pages/support/faq/Faq.jsx';
import ChangePassword from '../pages/teacher/components/ChangePassword.jsx'
import Logs from '../pages/teacher/components/Logs.jsx'
import SendCredentials from '../pages/teacher/components/SendCredentials.jsx'
import SendNotification from '../pages/teacher/components/SendNotification.jsx'
import Inbox from '../pages/inbox/Inbox.jsx';
import Instudion from "../pages/school/school.jsx"
import InstutionDetails from "../pages/school/components/InstudionDetails.jsx"
import Otp from '../pages/authpage/Otp.jsx';
import User from "../pages/user/user.jsx"
import Home from "../pages/temp/home.jsx"
import About from "../pages/temp/About.jsx"
import Contact from "../pages/temp/contact/Contact.jsx"
import Plans from '../pages/temp/plans/Plans.jsx';
import Gallery from "../pages/temp/gallery/Gallery.jsx"
import Features from "../pages/temp/Features.jsx"
import Services from "../pages/temp/Services.jsx"
import Solutions from "../pages/temp/Solutions.jsx"
import Blog from "../pages/temp/Blog.jsx"
import Testimonials from "../pages/temp/Testimonials.jsx"
import FAQ from "../pages/temp/FAQ.jsx"
import CaseStudies from "../pages/temp/CaseStudies.jsx"


export const initialRoutes = () => {
    const routes = [
        // ============ Auth ===============
         { path: "/login", type: "auth", component: Login },
        { path: "/otp", type: "auth", component: Otp},
        { path: "/forget_password", type: "auth", component: ForgetPassword },
        { path: "/reset_password", type: "auth", component: ResetPassword },
        { path: "/forgotpassword_otp", type: "auth", component: ForgetPasswordotp },
        // ============ Public =============
        // all public routes should be here

        { path: "/", type: "Public", component: Home },
        { path: "/features", type: "Public", component: Features },
        { path: "/services", type: "Public", component: Services },
        { path: "/solutions", type: "Public", component: Solutions },
        { path: "/about", type: "Public", component: About },
        { path: "/contact", type: "Public", component: Contact },
        { path: "/plans", type: "Public", component: Plans },
        { path: "/gallery", type: "Public", component: Gallery },
        { path: "/blog", type: "Public", component: Blog },
        { path: "/testimonials", type: "Public", component: Testimonials },
        { path: "/faq", type: "Public", component: FAQ },
        { path: "/case-studies", type: "Public", component: CaseStudies },
        
        // ============ Privet ==============
        { path: "/dashboard", type: "private", component: Dashboard, title: "Dashboard" },
        { path: "/teacher", type: "private", component: Client, title: "Teacher" },
        {
            path: "/teacher/:id", type: "private", component: ClientDetails, title: "Teacher Details",
            parent: [{ title: 'Teacher', path: '/teacher' }]
        },
        { path: "/student", type: "private", component: Student, title: "Student" },
        { path: "/instution", type: "private", component: Instudion, title: "Instution" },
        { path: "/instution_details/:id", type: "private", component: InstutionDetails, title: "Instution Details" },
        { path: "/user", type: "private", component: User, title: "Users" },

        
        { path: "/task", type: "private", component: Task, title: "Task" },
        { path: "/banner", type: "private", component: Banner, title: "Banner" },
        { path: "/ticket", type: "private", component: Ticket, title: "Ticket" },
        { path: "/view_ticket/:id", type: "private", component: ViewTicket, title: "View Ticket", parent: [{ title: 'Ticket', path: '/ticket' }] },
        { path: "/faq", type: "private", component: Faq, title: "Faq" },
        { path: "/inbox", type: "private", component: Inbox, title: "Inbox" },
        { path: "/faq", type: "private", component: FAQs, title: "FAQs" },
        { path: "/change_password", type: "private", component: ChangePassword, title: "Change Password" },
        {
            path: "/logs/:id", type: "private", component: Logs, title: "Logs",
            
            parent: [{ title: 'Teacher', path: '/teacher' }, { title: "Teacher Details", path: "/teacher_details/:id" }]
        },
      
        { path: "/send_credentials", type: "private", component: SendCredentials, title: "Send Credentials" },
        { path: "/send_notification", type: "private", component: SendNotification, title: "Send Notification" },
    ]
    return routes;
}

// export default initialRoutes